var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimplifyLanguage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6211 12.7173C17.7152 13.8114 17.7152 15.5853 16.6211 16.6795C15.527 17.7736 13.7531 17.7736 12.6589 16.6795C11.5648 15.5854 11.5648 13.8114 12.6589 12.7173C13.7531 11.6232 15.527 11.6232 16.6211 12.7173",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 8.15833V11.9",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16917 17.5001H3.43417C2.91833 17.5001 2.5 17.0817 2.5 16.5659V12.8309C2.5 12.3151 2.91833 11.8967 3.43417 11.8967H7.16917C7.685 11.8967 8.10333 12.3151 8.10333 12.8309V16.5659C8.10333 17.0817 7.685 17.5001 7.16917 17.5001Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6417 11.9V8.65002",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28275 3.37894C8.37686 4.47305 8.37686 6.24697 7.28275 7.3411C6.18863 8.43521 4.41471 8.43521 3.32059 7.3411C2.22647 6.24698 2.22647 4.47306 3.32059 3.37894C4.4147 2.28482 6.18862 2.28482 7.28275 3.37894",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7108 5.96088L15.2958 8.37588C14.9308 8.74088 14.34 8.74088 13.975 8.37588L11.56 5.96088C11.195 5.59588 11.195 5.00504 11.56 4.64004L13.975 2.22504C14.34 1.86004 14.9308 1.86004 15.2958 2.22504L17.7108 4.64004C18.075 5.00504 18.075 5.59588 17.7108 5.96088V5.96088Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2917 5.35832H8.10001",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimplifyLanguage);
export default ForwardRef;